export default "__VITE_ASSET__D2M4AuCG__"